// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"NK-z","carouselContainer":"OK-z"};